import React, { Fragment, memo } from 'react'
import { TInputEvent } from '../../global-type'
interface InputProps {
  t: React.HTMLInputTypeAttribute,
  n?: string,
  required?: boolean,
  defaultChecked?: boolean,
  v?: string, change: (e: TInputEvent) => void,
  plholder?: string,
  cls?: string
}
const Input: React.FC<InputProps> = ({ t, n, required, defaultChecked, v, change, plholder, cls }) => {
  const handleChange = () => change


  return (
    <Fragment>
      <input
        className={cls || ''}
        type={t}
        name={n}
        required={required || false}
        defaultChecked={defaultChecked || false}
        value={v}
        onChange={handleChange}
        placeholder={plholder || ''}
      />
    </Fragment>
  )
}

export default memo(Input)
